import { GenericService } from "./Generic.service";

export class ReaplicacaoService extends GenericService<any> {
  readonly URI: string = "Reaplicacao";

  constructor(empresaId: string) {
    super();
    this.setUri(`Empresa/${empresaId}/${this.URI}`);
  }

  public async getPostosTrabalho() {
    return await super.getByResource("PostosTrabalho");
  }

  public async getHistorico() {
    return await super.getByResource("Historico");
  }

  public async getUsuariosImpactados(id: string) {
    return await super.getByResource(`${id}/Usuarios`);
  }

  public async salvarParametrizacao(body: { dataCorte: string; postosTrabalho: string[] }) {
    return await super.post(body);
  }

  public async toggleStatus(id: string) {
    return await super.postByResource({}, `${id}/Toggle`);
  }
}
